module.exports = __webpack_public_path__ + "img/mascotte-error.17e89d76.png";